import { IPromoInfo } from '../types/newbuilding/promoInfo';
import { IApplicationState } from '../types/redux';

export const promosSelector = (state: IApplicationState): IPromoInfo[] => {
  return state.newbuilding.promoInfos;
};
